import React, { useEffect } from 'react';
import { trackEvent } from '../utils/matomoEvents';

export default function TestimonialSubmission() {
    // Track page view on mount
    useEffect(() => {
        trackEvent('Testimonials', 'ViewSubmissionForm', 'GoogleForm');
    }, []);

    return (
        <div className="testimonial-submission">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSccLtXN9psJ6xPuc2ra_DZvk9F7JFz9ChT31aH56YjsYs-OnA/viewform?usp=dialog"
                width="100%"
                height="800"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Testimonial Form"
            >
                Loading…
            </iframe>
            <style jsx>{`
        .testimonial-submission {
          padding: 2rem;
          max-width: 800px;
          margin: 0 auto;
        }

        header {
          text-align: center;
          margin-bottom: 2rem;
        }

        header h1 {
          font-size: 2.5rem;
          color: var(--text);
        }
      `}</style>
        </div>
    );
}